import { render, staticRenderFns } from "./UserChatHistoryWidget.vue?vue&type=template&id=4f150ef3&scoped=true"
import script from "./UserChatHistoryWidget.vue?vue&type=script&lang=js"
export * from "./UserChatHistoryWidget.vue?vue&type=script&lang=js"
import style0 from "./UserChatHistoryWidget.vue?vue&type=style&index=0&id=4f150ef3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f150ef3",
  null
  
)

export default component.exports